import React, { useState, useEffect } from 'react';
import { Container, Tabs, Tab, Box } from '@mui/material';
import MealLogger from './MealLogger';
import MealHistory from './MealHistory';
import FoodSearch from './FoodSearch';
import { useLanguage } from '../i18n/LanguageContext';
import api from '../api';

interface YesterdayMeal {
  description: string;
  estimated_calories: number | null;
  meal_type: string;
}

const MealsTab: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [yesterdayMeals, setYesterdayMeals] = useState<YesterdayMeal[]>([]);
  const { t } = useLanguage();

  useEffect(() => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const yStr = yesterday.toISOString().slice(0, 10);
    const start = `${yStr}T00:00:00Z`;
    const end   = `${yStr}T23:59:59Z`;
    api.get(`/meals?start_date=${encodeURIComponent(start)}&end_date=${encodeURIComponent(end)}`)
      .then(r => setYesterdayMeals(r.data))
      .catch((e) => console.error('MealsTab: failed to fetch yesterday meals:', e));
  }, []);

  const handleMealLogged = () => {
    setRefreshTrigger(prev => prev + 1);
    setTabValue(1);
  };

  return (
    <Container maxWidth="sm" sx={{ pt: 2 }}>
      <Tabs
        value={tabValue}
        onChange={(_, v) => setTabValue(v)}
        variant="fullWidth"
        sx={{ mb: 2 }}
      >
        <Tab label={t.logMeal} />
        <Tab label={t.history} />
        <Tab label={t.searchFood} />
      </Tabs>

      <Box sx={{ display: tabValue === 0 ? 'block' : 'none' }}>
        <MealLogger onMealLogged={handleMealLogged} yesterdayMeals={yesterdayMeals} active={tabValue === 0} />
      </Box>

      <Box sx={{ display: tabValue === 1 ? 'block' : 'none' }}>
        <MealHistory refreshCount={refreshTrigger} />
      </Box>

      <Box sx={{ display: tabValue === 2 ? 'block' : 'none' }}>
        <FoodSearch />
      </Box>
    </Container>
  );
};

export default MealsTab;
